import React, { Component } from "react";
import SingleSound from "../Sound/index";

import kiuas from "../../assets/kiuas.mp3";
import kalja from "../../assets/olut.mp3";
import loyly from "../../assets/loyly.mp3";
import vasta from "../../assets/vasta.mp3";
import lintu from "../../assets/Linnunlaulu2_ja_tuuli2.mp3";
import jarvi from "../../assets/lake.mp3";
import rage from "../../assets/M.o.v.e - Rage Your Dream.mp3";

import placeholder from "../../assets/icons/placeholder.png";
import kiuasicon from "../../assets/icons/kiuas.png";
import kaljaicon from "../../assets/icons/kalja.png";
import vastaicon from "../../assets/icons/vasta.png";
import löylyicon from "../../assets/icons/kiulu.png";
import lintuicon from "../../assets/icons/lintu.png";
import jarviicon from "../../assets/icons/jarvi.png"
import initiald from "../../assets/icons/initiald.png";

class Control extends Component {
  state = {
    presetKiuas: 0.8,
    presetOlut: 0.5,
    presetVasta: 0.3,
    presetLöyly: 0.5,
    presetLintu: 0.2
  }

  presetClicked = () => {
    if(document.getElementById("kiuassnd"))
    document.getElementById("kiuassnd").click();

    if(document.getElementById("kaljasnd"))
    document.getElementById("kaljasnd").click();

    if(document.getElementById("vastanan"))
    document.getElementById("vastanan").click();

    if(document.getElementById("löylysnd"))
    document.getElementById("löylysnd").click();

    if(document.getElementById("lintunan"))
    document.getElementById("lintunan").click();
  }

  preset2Clicked = () => {
    if(document.getElementById("kiuassnd"))
    document.getElementById("kiuassnd").click();

    if(document.getElementById("kaljanan"))
    document.getElementById("kaljanan").click();

    if(document.getElementById("vastasnd"))
    document.getElementById("vastasnd").click();

    if(document.getElementById("löylynan"))
    document.getElementById("löylynan").click();

    if(document.getElementById("lintusnd"))
    document.getElementById("lintusnd").click();
  }

  randomClicked = () => {
    let i = Math.random() >= 0.5, j = Math.random() >= 0.5, k = Math.random() >= 0.5, l = Math.random() >= 0.5, m = Math.random() >= 0.5;
    if(i===true){
      if(document.getElementById("kiuassnd"))
      document.getElementById("kiuassnd").click();
    }else if (i===false) { 
      if(document.getElementById("kiuasnan")) 
      document.getElementById("kiuasnan").click();
    }

    if(j===true){
      if(document.getElementById("kaljasnd"))
      document.getElementById("kaljasnd").click();
    }else if (j===false) {
      if(document.getElementById("kaljanan")) 
      document.getElementById("kaljanan").click();
    }

    if(k===true){
      if(document.getElementById("vastasnd"))
      document.getElementById("vastasnd").click();
    }else if (k===false) {
       if(document.getElementById("vastanan")) 
    document.getElementById("vastanan").click();
    }

    if(l===true){
      if(document.getElementById("löylysnd"))
      document.getElementById("löylysnd").click();
    }else if (l===false) { if(document.getElementById("löylynan")) 
      document.getElementById("löylynan").click();
    }

    if(m===true){
      if(document.getElementById("klintund"))
      document.getElementById("lintusnd").click();
    }else if (m===false) { if(document.getElementById("lintunan")) 
      document.getElementById("lintunan").click();
    }
  }

  render() {
    return (
      <div className="darken">
        <h2>Presets</h2>
        <p>
          <button className="preset" onClick={this.randomClicked}>Random</button>
          <button className="preset" onClick={this.presetClicked}>Proper heat</button>
          <button className="preset" onClick={this.preset2Clicked}>Take it easy</button>
        </p>
        <div id={this.props.id}>
          
          <SingleSound
            id="kiuas"
            sound={kiuas}
            picture={kiuasicon}
            loop={true}
            vol={this.state.presetKiuas}
          />
          <SingleSound
            id="kalja"
            sound={kalja}
            picture={kaljaicon}
            loop={false}
            vol={this.state.presetOlut}
          />
          <SingleSound
            id="vasta"
            sound={vasta}
            picture={vastaicon}
            loop={false}
            vol={this.state.presetVasta}
          />
          <SingleSound
            id="löyly"
            sound={loyly}
            picture={löylyicon}
            loop={false}
            vol={this.state.presetLöyly}
          />
          <SingleSound
            id="lintu"
            sound={lintu}
            picture={lintuicon}
            loop={true}
            vol={this.state.presetLintu}
          />
          <SingleSound
            id="jarvi"
            sound={jarvi}
            picture={jarviicon}
            loop={true}
            vol={this.state.presetLintu}
          />
          {/*<SingleSound id="rage" sound={rage} picture={initiald} loop={true} vol={0.5} />*/}
        </div>
      </div>
    );
  }
}

export default Control;
